import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { ReactComponent as SearchIcon } from '../../../images/public/header/search.svg'
const SearchBar = () => {
    const navigate = useNavigate();
    const [search,setSearch] = useState('');
    const searchFocus = () =>{
        $('#main_searchbar_search_input').addClass('active');
    }
    const searchBlur = () =>{
        $('#main_searchbar_search_input').removeClass('active');
    }
    const openSearch = ()=>{
        if(search !== ""){
            navigate('/search?q='+search);
        }
    }
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            if(search !== ""){
                navigate('/search?q='+search);
            }
        }
    }
    return (
        <div className='main_searchbar_wrapper'>
            <div className='main_searchbar_search_input' id='main_searchbar_search_input'>
                <input type="text" placeholder='Search Our Exclusive Products' onChange={(e)=>{setSearch(e.target.value)}} onKeyPress={handleKeyPress} value={search}/>
                <div className='main_searchbar_autocom_box'>
                    <div className='main_searchbar_container'>
                        <h6>Popular</h6>
                        <ul>
                            <Link to='/collection' onClick={searchBlur}><li>Men</li></Link>
                            <Link to='/collection' onClick={searchBlur}><li>Women</li></Link>
                            <Link to='/collection' onClick={searchBlur}><li>Kids</li></Link>
                        </ul>
                    </div>
                </div>
                <div className="main_searchbar_icon" onClick={openSearch}><SearchIcon width="22px" height='40px'/></div>
            </div>
        </div>
    )
}

export default SearchBar
